interface Node {
	id: string;
	frontmatter: Record<string, any>;
}

interface NodeWrapper {
	node: Node;
}

const isNodeFrontmatterArray = (arr: any[]): boolean => arr[0]?.node?.frontmatter ?? false;

export const flattenNodeFrontmatterArray = (arr: NodeWrapper[]): Record<string, any>[] =>
	arr.map(({ node }) => ({
		id: node.id,
		...node.frontmatter,
	}));

export const flattenNodeFrontmatterArrayIfRequired = (
	arr: any[] | NodeWrapper[],
): Record<string, any>[] =>
	isNodeFrontmatterArray(arr)
		? flattenNodeFrontmatterArray(arr as NodeWrapper[])
		: (arr as Record<string, any>[]);
